import { render } from "./material-picture.vue?vue&type=template&id=71591812&ts=true"
import script from "./material-picture.vue?vue&type=script&lang=ts"
export * from "./material-picture.vue?vue&type=script&lang=ts"

import "./material-picture.vue?vue&type=style&index=0&id=71591812&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__